import { environment } from "src/environments/environment";

export class PipelineDashboardData {
  public pipelineStageID: string;
  public pipelineGroupID: string;
  public pipelineID: string;
  public organizationOffice: string;
  public createdDate: Date; //test for errors
  public customerName: string;
  public contact: string;
  public productType: string;
  public product: string;
  public origin: string;
  public destination: string;
  public estimatedVolume: string;
  public unit: string;
  public pipelineStage: string;
  public pipelineStageTypeID: string;
  public expectedGP: number;
  public assignedTo: string;
  public comments: string;
  public year: number;
  public month: number;
  public week: number;
  public country: string;
  public serviceCode: string;
  public reportType: string;
  public handlingOffice: string;
  public customerSchema: string;

  constructor(
    pipelineStageID: string,
    pipelineGroupID: string,
    pipelineID: string,
    organizationOffice: string,
    createdDate: Date,
    customerName: string,
    contact: string,
    productType: string,
    product: string,
    origin: string,
    destination: string,
    estimatedVolume: string,
    unit: string,
    pipelineStage: string,
    pipelineStageTypeID: string,
    expectedGP: number,
    assignedTo: string,
    comments: string,
    year: number,
    month: number,
    week: number,
    country: string,
    serviceCode: string,
    reportType: string,
    handlingOffice: string,
    customerSchema: string
  ) {
    this.pipelineStageID = pipelineStageID;
    this.pipelineGroupID = pipelineGroupID;
    this.pipelineID = pipelineID;
    this.organizationOffice = organizationOffice;
    this.createdDate = createdDate;
    this.customerName = customerName;
    this.contact = contact;
    this.productType = productType;
    this.product = product;
    this.origin = origin;
    this.destination = destination;
    this.estimatedVolume = estimatedVolume;
    this.unit = unit;
    this.pipelineStage = pipelineStage;
    this.pipelineStageTypeID = pipelineStageTypeID;
    this.expectedGP = expectedGP;
    this.assignedTo = assignedTo;
    this.comments = comments;
    this.year = year;
    this.month = month;
    this.week = week;
    this.country = country;
    this.serviceCode = serviceCode;
    this.reportType = reportType;
    this.handlingOffice = handlingOffice;
    this.customerSchema = customerSchema;
  }
}

export class pipelineConsultant {
  public consultantID: string;
  public consultantName: string;

  constructor(consultantID: string, consultantName: string) {
    this.consultantID = consultantID;
    this.consultantName = consultantName;
  }
}

export class pipelineStats {
  public countProspect: number = 0;
  public countContacted: number = 0;
  public countVisited: number = 0;
  public countProposal: number = 0;
  public countWon: number = 0;
  public countLost: number = 0;
  public countFutureProspect: number = 0;
  public Prospect: number = 0;
  public Contacted: number = 0;
  public Visited: number = 0;
  public Proposal: number = 0;
  public Won: number = 0;
  public Lost: number = 0;
  public FutureProspect: number = 0;
  public pipelinePortifolio: pipelinePieCharts = new pipelinePieCharts();
  public ProspectChart: pipelinePieCharts = new pipelinePieCharts();
  public ContactedChart: pipelinePieCharts = new pipelinePieCharts();
  public VisitedChart: pipelinePieCharts = new pipelinePieCharts();
  public ProposalChart: pipelinePieCharts = new pipelinePieCharts();
  public WonChart: pipelinePieCharts = new pipelinePieCharts();
  public LostChart: pipelinePieCharts = new pipelinePieCharts();
  public FutureProspectChart: pipelinePieCharts = new pipelinePieCharts();

  constructor(
     countProspect?: number,
     countContacted?: number,
     countVisited?: number,
     countProposal?: number,
     countWon?: number,
     countLost?: number,
     countFutureProspect?: number,
     Prospect?: number,
     Contacted?: number,
     Visited?: number,
     Proposal?: number,
     Won?: number,
     Lost?: number,
     FutureProspect?: number
  ) {}

  private get countAll():number{
    return this.countProspect + this.countContacted + this.countVisited + this.countProposal + this.countWon + this.countLost + this.countFutureProspect;
  }

  public get toCountArray(): number[] {
    //count array
    return [
      this.countProspect ,
      this.countContacted ,
      this.countVisited ,
      this.countProposal ,
      this.countWon ,
      this.countLost,
      this.countFutureProspect
    ];
  }

  public get toGPArray(): number[] {
    //count array
    return [
      this.Prospect ,
      this.Contacted ,
      this.Visited ,
      this.Proposal ,
      this.Won ,
      this.Lost,
      this.FutureProspect
    ];
  }

  public get countContactedVsProspectRatio():string{
    if (this.countProspect === 0) return "0%";
    let ratio:number = (this.countContacted/this.countProspect) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get countVisitedVsConstctedRatio():string{
    if (this.countContacted === 0) return "0%";
    let ratio:number = (this.countVisited/this.countContacted) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get countProposalVsVisitedRatio():string{
    if (this.countVisited === 0) return "0%";
    let ratio:number = (this.countProposal/this.countVisited) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get countWonVsProposalRatio():string{
    if (this.countProposal === 0) return "0%";
    let ratio:number = (this.countWon/this.countProposal) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get countLostVsProposalRatio():string{
    if (this.countProposal === 0) return "0%";
    let ratio:number = (this.countLost/this.countProposal) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get countFutureVsProposalRatio():string{
    if (this.countProposal === 0) return "0%";
    let ratio:number = (this.countFutureProspect/this.countProposal) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPContactedVsProspectRatio():string{
    if (this.Prospect === 0) return "0%";
    let ratio:number = (this.Contacted/this.Prospect) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPVisitedVsConstctedRatio():string{
    if (this.Contacted === 0) return "0%";
    let ratio:number = (this.Visited/this.Contacted) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPProposalVsVisitedRatio():string{
    if (this.Visited === 0) return "0%";
    let ratio:number = (this.Proposal/this.Visited) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPWonVsProposalRatio():string{
    if (this.Proposal === 0) return "0%";
    let ratio:number = (this.Won/this.Proposal) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPLostVsProposalRatio():string{
    if (this.Prospect === 0) return "0%";
    let ratio:number = (this.Lost/this.Prospect) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPFutureVsProposalRatio():string{
    if (this.Proposal === 0) return "0%";
    let ratio:number = (this.FutureProspect/this.Proposal) * 100;
    return ratio.toFixed(2) +"%";
  }

  public get GPTotal(){
    let total = this.Prospect + this.Contacted + this.Visited + this.Proposal + this.Won + this.Lost;
    return total;
  }

  public get countTotal(){
    let total = this.countProspect + this.countContacted + this.countVisited + this.countProposal + this.countWon + this.countLost;
    return total;
  }
}

export class pipelinePieCharts {
  public dataSet: number[] = [];
  public dataLables: string[] = [];

  constructor(dataLables?: string[], dataSet?: number[]) {
    if (dataLables)
      this.dataLables = dataLables;
    if (dataSet)
      this.dataSet = dataSet;
  }

  public get dataSetToPercentage(): number[]{
    let percentageList:number[] = [];
    let total = 0;
    this.dataSet.forEach(itm => {
      total += itm;
    });
    this.dataSet.forEach(itm => {
      percentageList.push( +((itm/total)*100).toFixed(2));
    });
    return percentageList;
  }

  public get getDataLables(): string[]{
    let tempList: string[] = [];
    let persentageList = this.dataSetToPercentage;
    for (let i = 0; i < this.dataLables.length; i++){
      tempList.push(this.dataLables[i] + " " + persentageList[i] +"%");
    }
    return tempList;
  }
}

export class pipelineLineCharts {
  private data: { [key: string]: number[] } = {};
  private isSet: boolean = false;
  public dates: string[] = [];

  constructor() {
    Object.entries(environment.pipeline.pipelineStageTypeIds).forEach(([key, value]) => {
      this.data[value] = [];
    });
  }

  private setDataListLengths(): void{
    if (!this.isSet){
      Object.entries(environment.pipeline.pipelineStageTypeIds).forEach(([key, value]) => {
        while (this.data[value].length < this.dates.length){
          this.data[value].push(0);
        }
      });
      this.isSet = true;
    }
  }

  // Method to get data by label
  getDataByLabel(label: string): number[] {
    if (!this.data[label]){
      console.log(`Label ${label} not found.`);
    }
    return !!this.data[label] ? this.data[label] : [0];
  }

  // Method to update data for a specific label
  incrementDataForLabel(label: string, date: string): void {
    if (this.data[label]) {
      this.setDataListLengths();
      this.data[label][this.dates.indexOf(date)]++;
    } else {
      console.log(`Label ${label} not found1.`);
    }
  }
}
